import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { modal: String };

  connect() {
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this));
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      window.HSOverlay.close(this.modalValue);
    }
  }
}
